import { FirebaseTimeStamp } from '@models/dto/firebaseTimestamp.dto'

export const getDateFromFirebaseTimestamp = (firebaseDate: FirebaseTimeStamp): Date => {
    return new Date(firebaseDate._seconds * 1000)
}
